import { build, from, generate, get, Keys } from 'helpers/routes';

export const relations: Record<string, string> = {};

export const declarations = {
	'/': {},
	'#': {},
	'*': {},

	pricing: {},
	privacy: {},
	docs: {},

	auth: {
		logout: {},
		login: {},
		register: {},
		link: {},
	},

	legal: {
		terms: {},
		privacy: {},
	},

	dashboard: {
		commits: {},
		'api-keys': {},
		repositories: {},
		settings: {},
	},

	admin: {
		users: {
			'[userId]': {},
		},
		subscriptions: {
			plans: {
				create: {},
				'[planId]': {
					edit: {},
				},
			},
		},

		commits: {},
		analytics: {
			views: {},
		},
	},
};

export const references: Partial<Record<Keys<typeof declarations>, string>> = {
	admin: 'Admin',
	dashboard: 'Dashboard',

	users: 'Usuários',
	subscriptions: 'Assinaturas',
	analytics: 'Analytics',
	views: 'Visualizações',
	plans: 'Planos',
	'api-keys': 'Chaves de API',
	settings: 'Configurações',
	commits: 'Commits',
	repositories: 'Repositórios',

	create: 'Novo',
	edit: 'Editar',
};

export const formattedRoutes = generate(declarations, relations);

export const routes = {
	all: formattedRoutes,
	get: get(formattedRoutes),
	from: from(formattedRoutes),
	build: build(formattedRoutes),
};

export type Route = keyof typeof formattedRoutes & string;
export type Routes = typeof formattedRoutes;
